import styled from "styled-components";
import Img2 from "web/assets/images/self-managed-page.png"
// import Img2 from "../../../../assets/images/9Rectangle.png";

export const Container = styled.div``;
export const Wrapper = styled.div`
  h1,
  h2,
  h3,
  h4 {
    font-family: ITC Franklin Gothic Std;
  }
  max-width: 1440px;
  margin: 0 auto;
  p{
    font-size: 1.5rem;
   }
   h2 {
    font-size: 2.759rem;
  }
  h4{
    @media (max-width: 767px) {
        font-size: 32px !important;
    }
  }
  h2{
    @media (max-width: 767px) {
        font-size: 2rem !important;
    }
  }
  p{
    @media (max-width: 767px) {
        font-size: 14px !important;
    }
  }
  @media (max-width: 1024px){
    p{
      font-size: 14px;
    }
    h2{
      font-size: 2rem;
    }
  }
  @media (max-width: 1024px){
    p{
      font-size: 14px;
    }
    h2{
      font-size: 2rem;
    }
  }
  button {
    background-color: #233354;
    font-weight: 400;
    color: rgb(255, 255, 255);
    border: none;
    margin-top: min(1.75vw, 25px);
    font-size: 14px;
    padding: 8px 20px;
    width: 250px;
  }
  .our_expertise {
    background-color: #e3f1fb;
    width: 100%;
    background-repeat: repeat;
    background-position: right;
    /* margin-bottom: 4vw !important; */
    &.suppliers {
      background-image: url(${Img2});
      background-size: contain;
      height: 400px;
      @media (max-width: 1024px){
        height: 300px;
      }
      @media (max-width: 767px){
        height: 144px !important;
      }
    }

    .expertise_overlay {
      /* background: linear-gradient(109deg, #ee0000bf 50%, transparent 50%); */
      background: linear-gradient(109deg, #e20f0fde 50%, transparent 50%);
      height: 400px;
      color: #ffffff;
      padding: 16px;
      padding-left: 6.25vw;
      padding-right: 6.25vw;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      h2 {
        font-size: 4rem;
        font-weight: 500;
      }
    }
    @media (max-width: 1024px) {
      .expertise_overlay {
        height: 300px;
        h2 {
          font-size: 3rem;
        }
      }
     
    }
    @media (max-width: 767px) {
      background-size: cover;
      .expertise_overlay {
        background: linear-gradient(180deg, #ee0000c4 50%, #e3f1fb 34%);
        height: 270px;
        flex-direction: column;
        &.self h2{
          display: inline-block;
          padding-right: 9px;
        }
        h2 {
          font-size: 36px !important;
        }
        p {
          font-size: 14px;
        }
        
        .digital_supplier_img {
          img {
            max-width: 290px;
          }
        }
        .grid {
          display: grid;
          button {
            background-color: #ffffff;
            color: #ee0000;
            width: 270px;
          }
        }
      }
      &.suppliers {
        .expertise_overlay {
          background: linear-gradient(180deg, #ee0000c4 100%, #e3f1fb 34%);
          height: 144px !important;
          justify-content: center;
        }
      }
    }
  }
  .pallet_faq {
    margin: 2.5vw 3.5vw;
     &.last{
      padding-top:24px;
     }
    @media (max-width: 767px) {
      .how{
        font-size: 2rem !important;
      }
      margin: 5.5vw 3.5vw !important;
        }
        @media (max-width: 1024px){
          margin: 3.5vw 3.5vw;
        }
    @media (max-width: 767px) {
      margin: 5.5vw 3.5vw !important;
        }
        @media (max-width: 1024px){
          margin: 3.5vw 3.5vw;
        }
    .faq-head {
      text-align: center;
      /* margin-bottom: 40px; */
      h2 {
        /* font-size: 2.8rem !important; */
        font-family: ITC Franklin Gothic Std;
        color: #233354;
        @media (max-width: 767px) {
          /* font-size: 1.4rem !important; */
        }
      }
      p {
        color: #231f20;
        /* max-width: 718px; */
        text-align: center;
        /* margin: 16px auto; */
        margin-bottom: 0px;
        margin-top: 5px;
        @media (max-width: 767px) {
          margin-bottom: 25px;
        }
      }
    }
    .market{
      @media (max-width: 1024px){
          font-size:1.7rem !important;
        }
    }
    .market{
      @media (max-width: 1024px){
          font-size:1.4rem;
        }
    }
  }
  .digital_supplier {
    display: grid;
    grid-template-columns: 1fr 1fr;
    /* margin-top: -28px; */
    .digital_supplier_img {
      background-color: #e3f1fb;
      img {
        object-fit: cover;
        height: 100%;
        width: 100%;
      }
    }
    .digital_supplier-text {
      background-color: #233354;
      color: #ffffff;
      padding: 20px;
      display: grid;
      place-items: center;
      div {
        max-width: 410px;
      }
      h2 {
        margin-bottom: 40px;
      }
      button {
        background-color: #ffffff;
        color: #233354;
      }
    }
    @media (max-width: 1024px) {
      .digital_supplier_img {
        img {
          max-width: 518px;
        }
      }
    }
    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      margin: 5.5vw 3.5vw !important;
      width: auto;
      .digital_supplier_img {
        padding: 16px;
        display: flex;
        justify-content: center;
        img {
          max-width: 190px;
        }
      }
      .digital_supplier-text {
        h2 {
          font-size: 20px;
          margin-bottom: 20px;
        }
        p {
          font-size: 14px;
        }
      }
    }
  }
    * {
    box-sizing: border-box;
      }
  .what_you_get {
    font-family: sans-serif;
    display: flex;
    flex-direction: column;
    margin: 4vw 0;
    transform: scale(1);
    -ms-transform: scale (1);
    -webkit-transform:scale(1);
    -moz-transform: scale(1);
    -o-transform: scale(1);
    

    .what_you_get-container {
      background: #efefef;
    }

    .what_you_get-container > h2 {
      font-family: ITC Franklin Gothic Std;
      color: #233354;
      text-align: center;
      padding: 1.2rem;
      margin-bottom: -16px;
      @media (max-width: 767px){
        font-size: 2rem !important;
      }
    }

    .what_you_get-container > p {
      text-align: center;
      margin-top: 2px;
    }

    .what_you_get-container .cards-container {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 1rem;
    }
    .what_you_get-container .cards-container .card {
      display: flex;
      flex-direction: column;
    }

    .what_you_get-container .cards-container .card .img-box {
      background: #e4f1f9;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 1rem 1rem;
      position: relative;
      height: 218px;
      border: 2px solid #233354;
      #icon2-id{
        padding-top: 51px;
      }
    }

    .what_you_get-container .cards-container .card .text-box .hover-box {
      background: #233354;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 1.3rem;
      text-align: center;
      position: absolute;
      width: 100%;
      transform: scale(0);
      top: 0;
      left: 0;
      border: 1px solid #a6a6a6;
      z-index: 10;
      box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
      transition: all 0.4s;
      h4 {
        color: #ffffff;
      }
    }

    .what_you_get-container .cards-container .card .text-box .hover-box.active {
      display: flex;
      transform: scale(1.04);
      transition: all 0.4s;
      @media (max-width: 767px) {
        transform: scale(1);
        width: 100%;
      }
    }

    .what_you_get-container .cards-container .card .text-box .hover-box ul {
      margin: 0;
      margin-top: 1.3rem;
      padding: 0;
      color: #fff;
      list-style: none;
      text-align: start;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      font-size: 0.85rem;
    }

    .what_you_get-container .cards-container .card .text-box .hover-box > img {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 0.6rem;
      height: auto;
      cursor: pointer;
    }

    .what_you_get-container .cards-container .card .text-box .hover-box ul li {
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
      font-size: 19px;
      @media (max-width: 1024px){
        font-size: 15px;
      }
    }

    .what_you_get-container .cards-container .card .text-box .hover-box ul li img {
      width: 10px;
      height: auto;
      padding-top: 0.3rem;
    }

    .what_you_get-container .cards-container .card .text-box img {
      max-width: 100%;
      height: 100px;
      object-fit: contain;
    }

    .what_you_get-container .cards-container .card .text-box {
      background: #233354;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 1.3rem 1rem 1rem 1rem;
      text-align: center;
      gap: 0.5rem;
      flex: 1 1 0%;
      /* line-height: 190%; */
      position: relative;
    }

    .what_you_get-container .cards-container .card .text-box > h4,
    .what_you_get-container .cards-container .card .img-box .hover-box > h4 {
      font-size: 31px;
      color: #fff;
      font-weight: 500;
      margin: 0;
      @media (max-width: 1024px){
        font-size: 23px;
      }
      @media (max-width: 410px){
        font-size: 1.5rem !important;
      }
    }

    .what_you_get-container .cards-container .card .text-box > p {
      font-size: 1.2rem;
      color: #23759f;
      text-decoration: underline;
      margin: 0;
      cursor: pointer;
    }
    @media (max-width: 767px) {
      .cards-container {
        display: grid !important;
        grid-template-columns: 1fr !important;
        padding: 0 16px;
        .hover-box {
          /* width: 124% !important; */
        }
      }
    }
    /* for tablet */
    @media (min-width: 500px) and (max-width: 1050px) {
    }

    /* For Mobile */
    @media (max-width: 500px) {
    }
  }



  .color_box_wrp {
    margin: 3.5vw;
    margin-top: -28px;
    @media (max-width: 767px){
      margin: 0 !important;
    }
    @media (max-width: 1023px) {
      margin-right: 46px;
      margin-top: 51px;
    }
   }
  .list-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1.8rem;
    .item-container {
      display: flex;
      position: relative;
      min-height: 155px;
      @media (max-width: 767px) {
        margin-right: 21px;
      }
      @media (max-width: 1023px) {
        .icon-box p {
          text-align: left;
          margin-left: -22px;
          font-size: 25px !important;
          font-weight: 600;
          z-index: 2 !important;
        }
      }

      &.first {
        .number-box {
          .number {
            color: #00a5d7;
          }
        }
        .icon-box {
          background: #00a5d7;
        }
        .traingle {
          background-color: #00a5d7;
        }
      }
      &.second {
        .number-box {
          .number {
            color: #1a75bb;
          }
        }
        .icon-box {
          background: #1a75bb;
          flex-direction: column;
            /* gap: 0; */
          align-items: center;
          justify-content: center;
          /* line-height: 0.3; */
        }
        .traingle {
          background-color: #1a75bb;
        }
      }
      &.third {
        .number-box {
          .number {
            color: #293b8e;
          }
        }
        .icon-box {
          background: #293b8e;
        }
        .traingle {
          background-color: #293b8e;
        }
      }
      .number-box {
        background: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: translate(2rem, -4%);
        @media (max-width: 767px) {
          transform: translate(1rem, -34%);
        }
        .number {
          font-size: 9.3rem;
          line-height: 50%;
          font-weight: 800;
          position: relative;
          z-index: 11;
          @media (max-width: 767px) {
            line-height: 54%;
            position: relative;
            z-index: 11;
            font-size: 81px;
          }
        }
        .number-shadow {
          font-weight: 800;
          font-size: 9.3rem;
          line-height: 100%;
          -webkit-text-fill-color: #fff;
          -webkit-text-stroke: 25px;
          color: #fff;
          z-index: 10;
          position: absolute;
          @media (max-width: 767px) {
            /* font-size: 3.3rem; */
            /* display: none; */
            -webkit-text-stroke: 20px;
            font-size: 83px;
          }
        }
      }
      .bg-set {
        background: #d9f2f9;
        display: flex;
        width: 100%;
        .traingle {
          clip-path: polygon(100% 50%, 0 0, 0 101%);
          width: 55px;
          position: relative;
          left: -1px;
        }
        .description-box {
          display: flex;
          align-items: center;
          padding: 16px 3rem 0px;
          li {
            list-style: disc;
            line-height: 33px;
            color: #233354;
            margin-bottom: 7px;
            font-family: "latoregular", Arial, Helvetica, sans-serif;
            font-size:1.5rem;
          }
        }
        @media (max-width: 767px) {
          .traingle {
            width: 55px;
            left: -1px;
          }
          .description-box {
            padding: 16px 10px 0px 24px;
            li {
              font-size: 14px;
              line-height: 22px;
            }
          }
        }
      }
      .icon-box {
        width: 28%;
        color: #fff;
        display: flex;
        /* gap: 1rem; */
        align-items: center;
        padding-left: 4.5rem;
        text-align: center;
        p {
          font-size: 2rem;
          font-weight: 600;
          text-align: left;
        }
        @media (max-width: 767px) {
          padding-left: 33px;
          width: 228px;
          /* z-index: 10; */
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          /* line-height: 0; */
          .paras {
            margin-bottom: 0;
            margin-top: 0;
          }
          p {
            font-size: 17px !important;
            font-weight: 600;
            z-index: 28 !important;
            text-align: center;
            /* padding-left: 40px; */
            /* width: 90px; */
          }
        }
      }
      @media (max-width: 767px) {
      }
    }
  }

`;
